<template>
  <fragment>
      <template v-for="(item,ind) in menu" v-if="!item.hidden">
          <el-menu-item v-if="item.children==undefined||item.children.length == 0" :index="item.path" :key="item.path">
            <i v-if='item.meta!=undefined' :class="item.meta.icon"></i>
            <span slot="title">{{ item.name }}</span>
          </el-menu-item>
          <el-submenu v-else :index="item.path">
              <template slot="title">
                <i v-if='item.meta!=undefined' :class="item.meta.icon"></i>
                <span slot="title">{{ item.name }}</span>
              </template>
              <sidebarList :menu='item.children'></sidebarList>
            </el-submenu>
      </template >
  </fragment>
</template>

<script>
  export default {
    name:'sidebarList',
    data() {
      return{
        // sidebarWidth:false
      }
    },
    watch:{},
    props: ["menu"],
    computed:{},
    mounted() {},
    methods:{}
  }
</script>

<style>
</style>
